import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VList,
    {
      staticClass: "core-selection-list",
      attrs: { "data-qa": _vm.listDataQa },
    },
    [
      !_setup.preparedItems.length
        ? [_vm._t("empty")]
        : _vm._l(
            _setup.preparedItems,
            function ({ item, text, isSelected, highlightedText }, index) {
              return _c(
                VListItem,
                {
                  key: index,
                  ref: isSelected ? "selectedItemRef" : null,
                  refInFor: true,
                  staticClass: "core-selection-list__item",
                  attrs: { "data-qa": _vm.listItemDataQa },
                  on: {
                    click: function ($event) {
                      return _setup.onItemClick(item)
                    },
                  },
                },
                [
                  _vm._t(
                    "item",
                    function () {
                      return [
                        _c(VListItemContent, {
                          staticClass: "d-block text-body-1 text--text",
                          domProps: {
                            innerHTML: _vm._s(
                              highlightedText /* eslint-disable-line vue/no-v-text-v-html-on-component vue/no-v-html */
                            ),
                          },
                        }),
                      ]
                    },
                    {
                      item: item,
                      text: text,
                      isSelected: isSelected,
                      highlightedText: highlightedText,
                    }
                  ),
                  _vm._v(" "),
                  _vm._t(
                    "end-icon",
                    function () {
                      return [
                        _vm.endIcon === "check"
                          ? _c(
                              VListItemIcon,
                              [
                                isSelected
                                  ? _c(
                                      VIcon,
                                      { attrs: { color: "primary" } },
                                      [
                                        _vm._v(
                                          "\n            ui-icon-check\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm.endIcon === "arrow"
                          ? _c(
                              VListItemIcon,
                              [
                                _c(
                                  VIcon,
                                  { attrs: { color: "icon-secondary" } },
                                  [
                                    _vm._v(
                                      "\n            ui-icon-arrow-right\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    { item: item, isSelected: isSelected }
                  ),
                ],
                2
              )
            }
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }